// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"b61f2898","298":"dfcc4b14","306":"5f746c8a","724":"1c67e2ec","787":"2c1cee2b","987":"921989f0"}[chunkId] + ".chunk.js";
};